// extracted by mini-css-extract-plugin
export default {"splittingResultsLink":"dKYGBB6REzAchEBSKOPR"};